import { render, staticRenderFns } from "./objectReportDialog.vue?vue&type=template&id=4f7338e6&"
import script from "./objectReportDialog.vue?vue&type=script&lang=js&"
export * from "./objectReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports